const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isEhrRequestId(value) {
  const id = String(value || "").trim();
  return UUID.test(id) && id !== "00000000-0000-0000-0000-000000000000";
}

export function ehrStatusFromServer(state) {
  const status = String(state?.status || "").trim().toLowerCase();
  if (status === "requested" && !isEhrRequestId(state?.request?.id || state?.id)) return "";
  return status;
}

export async function submitConfirmedEhrRequest({ appointmentId, doctorId, patientId, submit }) {
  if (![appointmentId, doctorId, patientId].every(isEhrRequestId)) {
    throw new Error("Could not verify the clinician and patient for this EHR request. Please sign in and try again.");
  }
  const result = await submit();
  if (!isEhrRequestId(result?.requestId)) {
    throw new Error("Could not confirm that the EHR access request was saved. Please try again.");
  }
  return { ...result, requestId: String(result.requestId).trim() };
}
